import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { backgroundColors } from 'config'

class InputV2 extends Component {
  onChange = (event, props) => {
    if (props.onlyNumbers) {
      const re = /^[0-9\b]+$/
      if (event.target.value && !re.test(event.target.value)) {
        return false
      }
    }

    if (props.onlyDecimalNumbers) {
      const re = /(^[0-9]$)|(^[0-9](.|,)?$)|(^[0-9](.|,){1}[0-9]+$)/
      if (event.target.value && !re.test(event.target.value)) {
        return false
      }
    }

    props.onChange(event.target.value)
  }

  handleInputFocus = (e) => {
    const input = e.target.querySelector('input')
    if (input) {
      input.focus()
      const length = input.value.length

      if (input.type === 'number') {
        // Temporarily change type to text to set cursor position
        input.type = 'text'
        setTimeout(() => {
          input.setSelectionRange(length, length)
          input.type = 'number' // Revert back to number
        }, 0)
      } else {
        // For text inputs, directly set the cursor position
        input.setSelectionRange(length, length)
      }
    }
  }

  render() {
    const props = this.props

    return (
      <Label style={props.style}>
        <label style={props.labelStyle}>
          {props.label}
          {props.required && <b> *</b>}
        </label>
        <InputBg bgColor={backgroundColors.normalLeft}>
          <InputContent
            icon={Boolean(props.icon)}
            onClick={this.handleInputFocus}>
            <InnerInput
              id={props.id}
              valid={props.valid}
              value={props.value}
              type={props.type}
              required={props.required}
              autoComplete={'off'}
              onChange={(e) => {
                this.onChange(e, props)
              }}
              onBlur={(e) => props.onBlur && props.onBlur(props.validator)}
              placeholder={props.placeholder}
              maxLength={props.maxLength}
              className={props.className}
              fullWidth={!props.suffix}
            />
            {props.suffix && <Suffix>{props.suffix}</Suffix>}
            {props.icon}
          </InputContent>
        </InputBg>
        <Error valid={props.valid}>{props.errorMessage}</Error>
      </Label>
    )
  }
}

InputV2.defaultProps = {
  errorMessage: '',
  valid: true,
  placeholder: '',
}

InputV2.propTypes = {
  label: PropTypes.string,
  labelStyle: PropTypes.object,
  id: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  autoComplete: PropTypes.string,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  valid: PropTypes.bool,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  validator: PropTypes.func,
  suffix: PropTypes.string,
  icon: PropTypes.any,
}

export default InputV2

const Label = styled.div`
  position: relative;

  > label {
    color: #3e3e3e;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    margin: 0;
    text-transform: unset;

    > b {
      color: #c00000;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      margin: 0;
    }
  }
`

const InputBg = styled.div`
  background: #dedede;
  height: 40px;
  padding: 1px;
  box-sizing: border-box;

  &:focus-within {
    background: ${({ bgColor }) => bgColor};
  }
`

const InputContent = styled.div`
  width: 100%;
  height: 100%;
  padding-inline: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  flex: 1 0 0;

  cursor: pointer;

  ${({ icon }) => icon && 'justify-content: space-between;'}

  background-color: #fff;

  &:hover {
    background: #ececec;
  }
`

const InnerInput = styled.input`
  color: #616161;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 25px;

  background: transparent;
  border: none;

  field-sizing: content;
  min-width: 10px;
  padding: 0 !important;
  width: unset !important;

  ${({ fullWidth }) => fullWidth && 'flex: 1 0 0;'}

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:[type=number] {
    -moz-appearance: textfield;
  }
`
const Suffix = styled.span`
  color: #bababa;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  pointer-events: none;
`

const Error = styled.span`
  color: #c13e44;
  font-size: 12px;
  font-weight: 400;
  ${(props) => (props.valid === null || props.valid) && 'display: none;'}
  position: absolute;
`



// WEBPACK FOOTER //
// ./src/components/InputV2/index.js